/*
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2023-02-01 19:15:56
 * @LastEditors: pj
 * @LastEditTime: 2023-02-16 11:19:26
 */

import test from './modules/test'
import user from './modules/user'
import api from './modules/api'


export const state = () => ({
    roles: [], // [ 'admin', 'user' ]
    user_info: {},
    vip: "",
    uname: ''
})

export const getters = {
    roles: state => state.user.user_info.roles,
    vip: state => state.user.user_info.vip, //vip 等级
    uname: state => state.user.user_info.uname, //账户名
}

export const mutations = {

}
export const actions = {

}
export const modules = {
    test, user, api, getters
}
